firebird.factory('videoLayoutPageService', [
    '$rootScope',
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'helperService',
    'configService',
    'videoroomService',
    'analyticsWrapperService',
    'videoGlobalService',
    function (
        $rootScope,
        $timeout,
        $interval,
        $window,
        logService,
        helperService,
        configService,
        videoroomService,
        analyticsWrapperService,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoLayoutPageService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initLayoutPage = initLayoutPage;

            // pagination and pin

            self.layoutPage = false;
            self.layoutDebug = false; // true, false, "local" (to display only locally), or "save" (to save logs)
            self.layoutDebugLogs = []; // if "save" then store here.
            self.layoutDebugLogsMax = 100000; // how many lines of logs max.
            self.videoLabels = null;

            self.hasLayoutPagePrevious = false; // use these to bind to previous and next UI controls.
            self.hasLayoutPageNext = false;

            self.layoutVideoCount = 0; // derived from DOM, unlike videoCount below. needed without layoutPage too.
            self.layoutControls = { enable: false, allhands: false }; // to send in videoroom-layout-controls to headerCtrl.js

            self.layoutPageData = {
                layout: null, // gallery, spotlight, allhands or null (when pagination not enabled).
                videoSize: 'medium', // small, medium, large
                previousVideoSize: null, //used to remember original 'videoSize' when changing the value dynamically
                lowWebcamLimit: 'large', //videoSize used when high CPU detected
                cutoff: 20,
                pinnedFree: 4, // pagination enabled when > 30
                sizeCutoff: {
                    xsmall: [42, 54, 12],
                    small: [30, 30, 12],
                    medium: [20, 20, 7],
                    large: [12, 12, 7],
                    xlarge: [4, 6, 4],
                    default: [20, 20, 7]
                }, // cutoff, allhands size, spotlight less size
                currentPage: 0,
                currentIndex: 0,
                pageSize: 20,
                realSize: 20,
                rows: 5,
                // for allhands
                colums: 4,
                //show avatar as bg in video tiles
                hasAvatar: true,
                videoCount: 0,
                pinnedCount: 0,
                // number of videos or pinned videos
                hasSelf: false,

                // index fid, value is as follows:
                videos: {},
                // {pinned: true/false, self: true/false,
                // tsTalker: last talker timestamp, tsSilent: last silent timestamp,
                // tsSlotted: last timestamp when put to slots,
                // tsUnslotted: timestamp when put away from slots,
                // sortName: name string for sorting,
                // visible: whether it is shown on current view, or not.
                // content: true/false, div: ...}

                slots: [], // list of fid (string) for at most 30 (cutoff)
                ordered: [], // list of fid ordered by their sortName, included in all hands.
                pinned: [], // list of pinned fid from attendee list, even if not in videos dict.

                flipDuration: 500, // in milliseconds;
                pendingFlips: [], // we allow only one flip at a time. keep a queue.
                flipTimer: null,
                flipInterval: 60000,
                flipBucketSize: 5, // periodically flip videos if more than cutoff.

                talkerDuration: 10000, // keep the talker state 10s.
                talkerHistory: 30000, // quiet for 30s, means you will be preferred to be flipped.

                randomTalkerTimer: null, // whether randomly enable active talker for people periodically.
                randomTalkerInterval: 5000,
                randomTalkerVariance: 3000,

                // all hands configs.
                clickAction: 'ignore', // null (default), "ignore" (no action) or "pin" (toggle pin)
                addOnCurrentPage: true, // dynamically add on non-last page too.
                //removeOnCurrentPage: true, // dynamically remove from page.
                useSlidingWindow: false, // use page for index or index for page calculation, in a sliding window.
                changeCurrentPage: false, // whether to change page# on add/remove.
                includeContentVideo: false, // whether to include content video in all hands.
                includeSelfVideo: true, // if false, then use picture-in-picture overlay for self preview, in all views.
                alwaysUseOrdered: true, // optimize to always use ordered list instead of re-sorting every time.
                showPinnedLabel: true, // whether to alter label with pinned attribute.
                preferSquare: true, // whether to prefer closer to ratio2=1:1 (true) or ratio1=16:9 (false)
                showPreviousNext: true, // whether to show previous and next buttons.
                flexibleCount: true, // whether sizeCutoff second value is used as upper limit (true) or fixed (false)
                preferContentOverTalker: true, // prefer content view over active talker
                anchorFirst: true, // whether to anchor at first video or page number of size change.
                // other configs
                saveSpotlight: true, // save previous spotlight when navigating to allhands, and restore when back.
                savedSpotlight: null, // fid of saved.
                lessInSpotlight: false, // use less videos in spotlight compared to grid.
                lessInGrid: false, // use less videos in grid view.

                // animation configs
                animateGoto: true, // previous or next in all hands
                animateFlip: true, // replacing one with another in slots
                animateRemove: true, // hiding removed item with opacity and position transition
                animateAdd: true, // adding item.
                animateResize: false, // when window is resized.
                animateChange: true, // when changed for layout order
                animateToggle: false, // when videoToggle is changed.
                animateAllFlips: false, // if false, then avoid multiple animation if update needs to be done anyway.

                // testing related attributes
                wrapperDelay: false, // if true then add random delay for sending certain messages via wrapper.

                // workaround to reduce jumping video problem.
                // if 'delayupdate', then max update videos layout frequency one per 3s in allhands view.
                // if 'delayattendee' then apply alternate workaround for each attendee start/stop.
                // if '' or false, then do not apply any workaround.
                jumpingWorkaround: 'delayattendee',
                pendingUpdate: 0, // last time update was called in allhands layout.
                minUpdateDuration: 3000, // slow down to allow atmost one update in 3s. (for delayupdate)
                minRestartDuration: 3000, // delay next start if stop/start happens in quick succession. (for delayattendee)
                pendingSync: 0, // a sync was needed but did not complete.
                minSyncDuration: 2000, // delay sync if too many within this - at most one per 2s, but delay upto 3s.
                lastSyncTime: 0, // last time when attendee list was synced.
                missingRetryAfter: 4000, // if No such feed is received, do not retry again to attach or switch to that within 4s.
                playOnConnect: true // whether to wait for attendee connect before starting its video play.
            };

            self.layoutPageMissingFeed = {}; // key is fid, and value is last time "No such feed" error was received.
            self.layoutPageLastSyncTimeout = null; // timer to do sync if needed.
            self.layoutPageLastUpdateTimeout = null; // timer for lastUpdate above.
            self.layoutPageAttendeeData = {}; // fid to {div, ...} for pending

            self.layoutPageDataBackup = JSON.stringify(self.layoutPageData);

            self.resetLayoutPageData = resetLayoutPageData;
            self.logLayout = logLayout;
            self.parseLayoutPage = parseLayoutPage;
            self.setCurrentLayout = setCurrentLayout;
            self.onLayoutPageShowLayout = onLayoutPageShowLayout;
            self.onLayoutPageToggleSpotlight = onLayoutPageToggleSpotlight;
            self.onLayoutPageUpdateNextPrevious = onLayoutPageUpdateNextPrevious;
            self.onLayoutPageUpdateControls = onLayoutPageUpdateControls;
            self.selectLayoutPageSpotlight = selectLayoutPageSpotlight;
            self.onLayoutPageGoto = onLayoutPageGoto;
            self.onLayoutPageSet = onLayoutPageSet;
            self.getLayoutInputVideos = getLayoutInputVideos;
            self.getLayoutPageAllHands = getLayoutPageAllHands;
            self.isLayoutPageVideoExpandable = isLayoutPageVideoExpandable;
            self.addLayoutVideoItem = addLayoutVideoItem;
            self.removeLayoutVideoItem = removeLayoutVideoItem;
            self.onLayoutPageRemoving = onLayoutPageRemoving;
            self.onLayoutPageOrderedSlots = onLayoutPageOrderedSlots;
            self.onLayoutPageFlip = onLayoutPageFlip;
            self.onLayoutPageToggleFlip = onLayoutPageToggleFlip;
            self.flipVideoLayout = flipVideoLayout;
            self.processNextPendingFlip = processNextPendingFlip;
            self.startLayoutPageFlipTask = startLayoutPageFlipTask;
            self.stopLayoutPageFlipTask = stopLayoutPageFlipTask;
            self.onLayoutPagePeriodicFlip = onLayoutPagePeriodicFlip;
            self.processFlipNoAnimate = processFlipNoAnimate;
            self.onLayoutPageToggleTalker = onLayoutPageToggleTalker;
            self.onLayoutPageRandomTalker = onLayoutPageRandomTalker;
            self.onLayoutPageUpdateTalker = onLayoutPageUpdateTalker;
            self.getLayoutPageRandomSlot = getLayoutPageRandomSlot;
            self.setVideoTalking = setVideoTalking;
            self.setLayoutPageVideoSlotted = setLayoutPageVideoSlotted;
            self.isLayoutPageRecentTalker = isLayoutPageRecentTalker;
            self.onLayoutPageRemoveOneSlot = onLayoutPageRemoveOneSlot;
            self.getLayoutPageRandomUnslot = getLayoutPageRandomUnslot;
            self.onLayoutPageRecalculatePage = onLayoutPageRecalculatePage;
            self.disableAnimationOnAllVideos = disableAnimationOnAllVideos;
            self.onLayoutPageVideoChanges = onLayoutPageVideoChanges;
            self.onLayoutPageVideoMove = onLayoutPageVideoMove;
            self.onLayoutPageUpdateLessCutoff = onLayoutPageUpdateLessCutoff;
            self.onLayoutPageUpdateCutoff = onLayoutPageUpdateCutoff;
            self.onLayoutPageResetAll = onLayoutPageResetAll;
            self.onLayoutPageBeforeUpdate = onLayoutPageBeforeUpdate;
            self.onLayoutPageDelayAttendeeListSync = onLayoutPageDelayAttendeeListSync;
            self.onLayoutPageDelayMissingFeed = onLayoutPageDelayMissingFeed;
            self.onLayoutPageJumpingWorkaround = onLayoutPageJumpingWorkaround;
            self.onLayoutVideoCountChange = onLayoutVideoCountChange;
            self.onLayoutPageLowWebcamLimit = onLayoutPageLowWebcamLimit;

            self.layoutPageAnimationAttrs = [
                'animateGoto',
                'animateFlip',
                'animateRemove',
                'animateAdd',
                'animateResize',
                'animateChange',
                'animateToggle',
                'animateAllFlips'
            ];

            self.layoutPageDisableAnimation = layoutPageDisableAnimation;
            self.layoutPageUpdateAnimation = layoutPageUpdateAnimation;
        }

        // update from config
        function initLayoutPage() {
            self.layoutPage = self.parseLayoutPage(configService.getValue('layoutPage'));

            var layoutDebug = configService.getValue('layoutDebug');
            self.layoutDebug =
                layoutDebug == 'true' ? true : layoutDebug && layoutDebug != 'false' ? layoutDebug : false;

            self.videoLabels = configService.getClientValue('videoLabels') || null;
            if (self.videoLabels) {
                $window.$('#videoroom-videos').attr('videoLabels', self.videoLabels);
            } else {
                $window.$('#videoroom-videos').removeAttr('videoLabels');
            }

            // low webcam limit if either videoLow or videoLowOnCpu are set.
            self.onLayoutPageLowWebcamLimit(self.getIsVideoLowLayout());
        }

        function resetLayoutPageData() {
            self.logLayout('reset layoutPageData');
            self.layoutPageData = JSON.parse(self.layoutPageDataBackup);
        }

        function logLayout() {
            if (self.layoutDebug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift('LAYOUT');
                if (self.layoutDebug == 'local' || self.layoutDebug == 'save') {
                    console.info.apply(console, args); // keep this for logging locally during local dev.
                    if (self.layoutDebug == 'save') {
                        self.layoutDebugLogs.push(
                            args
                                .map(function (arg) {
                                    return '' + arg;
                                })
                                .join(' ')
                        );
                        if (self.layoutDebugLogs.length > self.layoutDebugLogsMax) {
                            self.layoutDebugLogs.splice(0, self.layoutDebugLogs.length - self.layoutDebugLogsMax);
                        }
                    }
                } else {
                    logService.log.apply(logService, args);
                }
            }
        }

        // update config and return boolean
        function parseLayoutPage(value) {
            if (!value || value == 'true' || value == 'false') {
                return value == 'true';
            } else {
                // comma separated name, value
                var data = self.layoutPageData;
                var oldCutoff = data.cutoff;
                var params = {};
                value.split(',').forEach(function (nv) {
                    var index = nv.indexOf(':');
                    if (index >= 0) {
                        var name = nv.substring(0, index);
                        var val = nv.substring(index + 1);
                        if (data[name] !== undefined) {
                            try {
                                params[name] = data[name] = JSON.parse(val);
                            } catch (e) {
                                params[name] = data[name] = val || null; // assume string
                            }
                        }
                    }
                });
                if (params.videoSize !== undefined || params.lessInGrid) {
                    // other attrs depend on this.
                    var sizeCutoff = data.sizeCutoff[data.videoSize] || data.sizeCutoff.default;
                    data.cutoff = data.lessInGrid ? sizeCutoff[2] : sizeCutoff[0];
                    data.pageSize = sizeCutoff[1];
                }
                if (oldCutoff != data.cutoff) {
                    self.onLayoutReuseUpdateCutoff();
                    self.onLayoutPageUpdateCutoff(oldCutoff, data.cutoff); // to allow changing lessInGrid.
                }
                if (!data.includeSelfVideo) {
                    $window.$('#videoroom').attr('preview', 'pip');
                } else {
                    $window.$('#videoroom').removeAttr('preview');
                }

                // do not print videos, as it is not a primitive type and causes circular dependency.
                self.logLayout(
                    'parse layoutPageData ' + JSON.stringify(Object.assign({}, data, { videos: undefined }))
                );
                return true;
            }
        }

        function setCurrentLayout(value) {
            videoroomService.setCurrentLayout(value);

            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            oldValue = data.layout;
            data.layout = value;
            self.logLayout('setCurrentLayout() ' + oldValue + '=>' + value);
        }

        // TODO: refactor with onChangeVideoroomLayout to avoid duplicate and one-direction invocations.
        function onLayoutPageShowLayout(value) {
            if (value == 'allhands' && !self.layoutPage) {
                logger.warn('onLayoutPageShowLayout', 'cannot change to allhands if layoutPage is not enabled');
                return;
            }

            if (self.layoutLock == 'locked' && !self.isHost) {
                // only host can change locked layout.
                logService.log('videoroomCtrl cannot change locked layout if not host');
                return;
            }

            if (value == 'allhands' && self.videoToggle && self.videoTogglePaused.videos) {
                logService.log('videoroomCtrl - cannot switch to all hands when videos are paused');
                return;
            }

            var data = self.layoutPageData;
            var oldValue = data.layout;
            if (value != oldValue) {
                self.logLayout('layoutPageData.layout=' + oldValue + '=>' + value);
                self.msgflowEvent('page:show:' + value, { old: oldValue });
                if (oldValue == 'allhands' && !data.addOnCurrentPage) {
                    // sort before doing anything
                    self.logLayout('sorting ordered list');
                    data.ordered.sort(function (a, b) {
                        var an = data.videos[a],
                            bn = data.videos[b];
                        return an.sortName < bn.sortName ? -1 : an.sortName > bn.sortName ? 1 : 0;
                    });
                }

                var setSimulcast = false; // delay setSimulcast after update of layout, so that enable attr is right.
                if (oldValue == 'spotlight') {
                    // remove maxvideo
                    if (self.maxvideo) {
                        if (data.saveSpotlight) {
                            data.savedSpotlight = self.maxvideo.getAttribute('user');
                        }
                        self.onLayoutPageToggleSpotlight(self.maxvideo, true, true);
                        setSimulcast = true;
                    }
                }

                self.onLayoutPageUpdateLessCutoff(oldValue, value);

                if (value == 'allhands') {
                    self.preferredLayout = 'allhands';
                    self.setCurrentLayout(value);
                    data.currentPage = 0; // start at page 0.
                    data.currentIndex = 0;
                } else if (value == 'spotlight') {
                    self.preferredLayout = 'spotlight';
                    self.setCurrentLayout(value);
                    var div0 = self.selectLayoutPageSpotlight();
                    if (div0 && div0 !== self.maxvideo) {
                        self.onLayoutPageToggleSpotlight(div0, true, true);
                        setSimulcast = true;
                    } else {
                        //Not sure if this can happen in practice because user can only switch layouts when other feeds are available...
                        logService.log('videoroomCtrl unable to find a video to set as spotlight');
                    }
                } else if (value == 'grid' || value == 'gallery') {
                    self.setCurrentLayout('gallery');
                    data.layout = self.preferredLayout = 'grid';
                }

                self.onLayoutPageUpdateNextPrevious();

                if (oldValue == 'allhands' || value == 'allhands') {
                    // do not animate to/from allhands
                    self.disableAnimationOnAllVideos(function () {
                        self.updateVideosLayout();
                        if (setSimulcast) {
                            self.simulcastReason = 'onLayoutPageShowLayout without animation';
                            self.setSimulcastForAllVideos();
                        }
                    });
                } else {
                    // animate between spotlight and gallery.
                    self.updateVideosLayout();
                    if (setSimulcast) {
                        self.simulcastReason = 'onLayoutPageShowLayout with animation';
                        self.setSimulcastForAllVideos();
                    }
                }
            }
        }

        // This is refactored from toggleVideoFullsize and setSpotlightVideo combined. It does not call
        // updateVideosLayout, and caller must call that if needed. It is currently called only for
        // layoutPage flag enabled, but eventually should be called in all cases.
        //
        // To toggle the full size property of a video element, update the max video property,
        // and re-do the videos layout. Also update the simulcast for remote video feeds.
        // Note that at most one video element may be in full size at any time. If the video
        // element is not full size, it is marked as full size and any previous full size is
        // unmarked. If the video element is already full size, then it is marked as not
        // full size, so that no video element is full size in the layout. If null is supplied, it is
        // treated as if the existing video element if any is supplied to disable full size.
        // The second parameter noSetLayout must be supplied as true, if the caller is responsible
        // for setting the layout, such as for all hands or other. This function changes layout only
        // between spotlight and gallery for backward compatibility.
        function onLayoutPageToggleSpotlight(videodiv, noSetLayout, noSetSimulcast) {
            if (!self.layoutPage) {
                logger.error('onLayoutPageToggleSpotlight', 'function called without layoutPage flag');
                return;
            }

            var data = self.layoutPageData;

            var oldmax = self.maxvideo;
            self.logLayout('toggle spotlight ' + !!oldmax + '=>' + !!videodiv);

            if (self.maxvideo == videodiv) {
                self.maxvideo = null;
            } else {
                self.maxvideo = videodiv;
            }

            if (!noSetLayout) {
                var oldLayout = data.layout;

                if (oldmax && !self.maxvideo) {
                    // switch from spotlight to gallery | allhands
                    if (self.preferredLayout == 'allhands') {
                        //switch to all hands if was all hand before screenshare
                        self.setCurrentLayout('allhands');
                    } else if (data.layout != 'gallery') {
                        // but not if already gallery.
                        self.setCurrentLayout('gallery');
                    }
                } else if (!oldmax && self.maxvideo) {
                    // switch from gallery or allhands to spotlight
                    if (data.layout != 'spotlight') {
                        // but not if already spotlight
                        self.setCurrentLayout('spotlight');
                    }
                }

                self.onLayoutPageUpdateLessCutoff(oldLayout, data.layout);
                self.onLayoutPageUpdateNextPrevious();
            }

            if (!self.maxvideo) {
                $window.$('#videoroom-videos').removeAttr('hasSpotlight');
            } else {
                $window.$('#videoroom-videos').attr('hasSpotlight', 'true');
            }
            if (oldmax) {
                oldmax.removeAttribute('spotlight');
            }
            if (self.maxvideo) {
                self.maxvideo.setAttribute('spotlight', 'true');

                var fid = self.maxvideo.getAttribute('user');
                if (data.slots.indexOf(fid) < 0) {
                    self.logLayout('update talker fid=' + fid + ' is not in slots, bringing in');
                    var oldfid = self.getLayoutPageRandomSlot();
                    if (oldfid) {
                        var index2 = data.slots.indexOf(oldfid);
                        self.logLayout('putting to slots at index=' + index2 + ' replacing fid=' + oldfid);
                        data.slots.splice(index2, 1, fid);
                        self.setLayoutPageVideoSlotted(oldfid, false);
                        self.setLayoutPageVideoSlotted(fid, true);

                        if (self.layoutOrder && self.layoutOrder != 'id') {
                            self.onLayoutPageOrderedSlots();
                        }
                    } else {
                        self.logLayout('cannot find a slot to replace with new talker fid=' + fid);
                    }
                }
            }

            if (!noSetSimulcast) {
                if (oldmax && self.maxvideo && oldmax !== self.maxvideo) {
                    // layout remains, just reconfigure two videos.
                    self.simulcastReason = 'onLayoutPageToggleSpotlight switched spotlight';
                    self.setSimulcast(oldmax);
                    self.setSimulcast(self.maxvideo);
                } else {
                    self.simulcastReason = 'onLayoutPageToggleSpotlight change related to spotlight';
                    // layout changed, need to reconfigure all videos.
                    self.setSimulcastForAllVideos();
                }
            }
        }

        function onLayoutPageUpdateNextPrevious() {
            self.logLayout('calling videoLayoutPageService->onLayoutPageUpdateNextPrevious()');
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            var oldPrevious = self.hasLayoutPagePrevious,
                oldNext = self.hasLayoutPageNext;
            if (data.showPreviousNext && self.layoutPageData.layout == 'allhands') {
                var videoCount = data.ordered.length;
                var pageCount = Math.ceil(videoCount / data.realSize);
                self.hasLayoutPagePrevious = data.currentPage > 0 || data.currentIndex > 0;
                self.hasLayoutPageNext =
                    data.currentPage < pageCount - 1 || data.currentIndex + data.realSize < videoCount;
            } else {
                self.hasLayoutPagePrevious = self.hasLayoutPageNext = false;
            }

            self.logLayout(
                'onLayoutPageUpdateNextPrevious() oldPrevious:' +
                    oldPrevious +
                    ' self.hasLayoutPagePrevious:' +
                    self.hasLayoutPagePrevious +
                    ' oldNext:' +
                    oldNext +
                    ' self.hasLayoutPageNext:' +
                    self.hasLayoutPageNext
            );
            if (oldPrevious != self.hasLayoutPagePrevious || oldNext != self.hasLayoutPageNext) {
                // to avoid calling if no change.
                digest();
            }
        }

        function selectLayoutPageSpotlight() {
            // do not check for layoutPage flag.
            // do not use enable="true" attribute to select the next spotlight.

            var data = self.layoutPageData;
            list = [];

            if (data.saveSpotlight && data.savedSpotlight) {
                // if saved exists, prefer that.
                var saved = data.savedSpotlight;
                data.savedSpotlight = null;
                var item = data.videos[saved];
                if (item) {
                    if (
                        data.slots.indexOf(saved) >= 0 &&
                        ((item.content && !self.isVideoTogglePaused(true)) ||
                            (!item.content && !self.isVideoTogglePaused(false)))
                    ) {
                        list.push(saved);
                    }
                }
            }

            if (!list.length && !self.isVideoTogglePaused(true)) {
                // get list of contents
                list = data.slots.filter(function (fid) {
                    return data.videos[fid].content;
                });
            }

            if (!list.length && !self.isVideoTogglePaused(false)) {
                // get remote items
                list = data.slots.filter(function (fid) {
                    return !data.videos[fid].self;
                });
            }

            if (!list.length) {
                // get self if present
                list = data.slots.filter(function (fid) {
                    return data.videos[fid].self;
                });
            }

            if (!list.length) {
                return null;
            }

            // if multiple found, then use last talker or most recent slotted.
            if (list.length > 1) {
                var now = Date.now();
                var list0 = list.slice(0);
                var list1 = list.filter(function (fid) {
                    return self.isLayoutPageRecentTalker(fid, now);
                });
                if (list1.length) {
                    list = list1;
                }
                if (list.length > 0) {
                    list = list.sort(function (a, b) {
                        var t1 = data.videos[a].tsSilent,
                            t2 = data.videos[b].tsSilent;
                        return (t2 < now - data.talkerHistory ? 0 : t2) - (t1 < now - data.talkerHistory ? 0 : t1);
                    });
                }

                if (list.length > 1 && data.videos[list[0]].tsSilent >= now - data.talkerHistory) {
                    // a workaround for now to return most recent talker.
                    list.splice(1, list.length - 1); // remove all except first.
                }
                // else list may have multiple

                if (!list.length) {
                    logger.warn(
                        'selectLayoutPageSpotlight',
                        'logic error in pruning the list for recent talker',
                        list0.join(',')
                    );
                }
            }

            // pick a random instead of first if multiple.
            var fid = list[Math.floor(Math.random() * list.length)];
            return data.videos[fid].div;
        }

        function onLayoutPageGoto(dir) {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;
            if (data.layout == 'allhands') {
                self.logLayout('layoutPageGoto() ' + dir);
                self.msgflowEvent('page:goto:' + dir, {
                    currentPage: data.currentPage,
                    currentIndex: data.currentIndex
                });

                if (!data.addOnCurrentPage) {
                    // sort before doing anything
                    self.logLayout('sorting ordered list');
                    data.ordered.sort(function (a, b) {
                        var an = data.videos[a],
                            bn = data.videos[b];
                        return an.sortName < bn.sortName ? -1 : an.sortName > bn.sortName ? 1 : 0;
                    });
                }

                var delta = dir == 'previous' ? -1 : 1;
                var videoCount = data.ordered.length;
                var previous = {
                    start: data.currentIndex,
                    end: Math.min(videoCount, data.currentIndex + data.realSize)
                };
                var pageCount = Math.ceil(videoCount / data.realSize);
                if (pageCount == 0) {
                    data.currentIndex = 0;
                    data.currentPage = 0;
                    self.onLayoutPageUpdateNextPrevious();
                    self.logLayout(
                        'resetting index and page, index=' + data.currentIndex + ' page=' + data.currentPage
                    );
                    return;
                }
                if (data.useSlidingWindow) {
                    // calculate page from index
                    data.currentIndex = Math.min(
                        Math.max(0, data.currentIndex + delta * data.realSize),
                        videoCount - data.realSize
                    );
                    data.currentPage = Math.floor(data.currentIndex / data.realSize);
                    self.logLayout('use sliding window, index=' + data.currentIndex + ' page=' + data.currentPage);
                    // TODO: pageCount may be +1 if new added before currentIndex
                } else {
                    // calculate index from page
                    data.currentPage = Math.min(Math.max(0, data.currentPage + delta), pageCount - 1);
                    data.currentIndex = data.currentPage * data.realSize; // reset index to beginning of page.
                    self.logLayout('updating, index=' + data.currentIndex + ' page=' + data.currentPage);
                }

                self.onLayoutPageUpdateNextPrevious();

                var next = { start: data.currentIndex, end: Math.min(videoCount, data.currentIndex + data.realSize) };

                // range previous to next.
                var existing = [],
                    newones = [],
                    common = [];
                var first = null;
                for (var i = previous.start, k = 0; i < previous.end; ++i, ++k) {
                    var div = data.videos[data.ordered[i]].div;
                    if (!first) {
                        first = div;
                    }
                    if (i >= next.start && i < next.end) {
                        // exists in next
                        common.push({ div: div, index: k });
                    } else {
                        existing.push({ div: div, index: k });
                    }
                }
                for (var j = next.start, l = 0; j < next.end; ++j, ++l) {
                    var div1 = data.videos[data.ordered[j]].div;
                    if (j < previous.start || j >= previous.end) {
                        // does not exist in previous
                        newones.push({ div: div1, index: l });
                    }
                }

                self.logLayout(
                    'changes, existing=' + existing.length + ', newones=' + newones.length + ', common=' + common.length
                );

                if (!data.animateGoto || self.layoutLock == 'locked') {
                    // animation does not look good for locked layout.
                    self.disableAnimationOnAllVideos(function () {
                        self.updateVideosLayout();
                    });
                } else {
                    // make newones appear from right or left, based on dir=next or previous
                    var w0 = first.offsetWidth,
                        h0 = first.offsetHeight;
                    var parentNode = $window.$('#videoroom-videos').get(0);
                    var W = parentNode.offsetWidth,
                        H = parentNode.offsetHeight;

                    newones.forEach(function (item) {
                        var div = item.div;
                        var index = item.index;
                        div.setAttribute('animate', 'false');
                        div.setAttribute('enable', 'true');
                        var r = Math.floor(index / data.columns);
                        var c = index % data.columns;
                        var x,
                            y = r * h0;
                        if (dir == 'previous') {
                            x = -W + c * w0;
                        } else {
                            x = W + c * w0;
                        }
                        // do not use 'style' attribute directly to avoid border change for portrait video.
                        div.style.top = Math.round(y) + 'px';
                        div.style.left = Math.round(x) + 'px';
                        div.style.width = Math.round(w0) + 'px';
                        div.style.height = Math.round(h0) + 'px';
                        div.style.zIndex = 2;
                        div.style.display = 'block';
                        div.style.visibility = 'visible';
                    });
                    $timeout(function () {
                        newones.forEach(function (item) {
                            var div = item.div;
                            div.removeAttribute('animate');
                        });
                        existing.forEach(function (item) {
                            // save existing style, to avoid animation when position/size set to 0
                            var div = item.div;
                            div.setAttribute('animate', 'false');
                            div.oldStyle = div.getAttribute('style');
                        });

                        self.updateVideosLayout();

                        existing.forEach(function (item) {
                            var div = item.div;
                            div.setAttribute('style', div.oldStyle);
                            delete div.oldStyle;
                            div.removeAttribute('animate');
                            div.setAttribute('enable', 'true');
                            // this may not be needed.
                            div.style.display = 'block';
                            div.style.visibility = 'visible';
                        });
                        $timeout(function () {
                            existing.forEach(function (item) {
                                var div = item.div;
                                var index = item.index;
                                var r = Math.floor(index / data.columns);
                                var c = index % data.columns;
                                var x,
                                    y = r * h0;
                                if (dir == 'previous') {
                                    x = W + c * w0;
                                } else {
                                    x = -W + c * w0;
                                }
                                // do not use 'style' attribute directly to avoid border change for portrait video.
                                div.style.top = Math.round(y) + 'px';
                                div.style.left = Math.round(x) + 'px';
                                div.style.width = Math.round(w0) + 'px';
                                div.style.height = Math.round(h0) + 'px';
                            });

                            $timeout(function () {
                                newones.forEach(function (item) {
                                    var div = item.div;
                                    div.style.zIndex = '';
                                });
                                existing.forEach(function (item) {
                                    var div = item.div;
                                    div.setAttribute('enable', 'false');
                                    div.setAttribute(
                                        'style',
                                        'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;'
                                    );
                                });
                            }, 300); // must match 0.3s of transition css.
                        }, 0);
                    }, 0);
                }
            } else {
                self.logLayout('cannot goto if not in allhands, layout=' + data.layout);
            }
        }

        function onLayoutPageSet(size) {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;
            var oldValue = data.videoSize;
            self.logLayout('layoutPageData.videoSize=' + oldValue + '=>' + size);
            if (size == oldValue) {
                self.logLayout('cannot set to same size old=new=' + size);
                return;
            }
            self.msgflowEvent('page:size:' + size, { old: oldValue, layout: data.layout });

            if (
                data.sizeCutoff[data.videoSize][0] <= self.maxVideoCountForFlexibleLayout &&
                data.layoutMethod !== undefined
            ) {
                self.logLayout('restore previous layoutMethod=' + self.layoutMethod + '=>' + data.layoutMethod);
                self.layoutMethod = data.layoutMethod;
                delete data.layoutMethod;
            }

            data.videoSize = size;

            var previous = data.cutoff;

            var sizeCutoff = data.sizeCutoff[data.videoSize] || data.sizeCutoff.default;
            data.cutoff =
                data.lessInGrid || (data.lessInSpotlight && data.layout == 'spotlight') ? sizeCutoff[2] : sizeCutoff[0];
            data.pageSize = sizeCutoff[1];
            if (data.cutoff <= self.maxVideoCountForFlexibleLayout) {
                self.logLayout('store existing layoutMethod=' + self.layoutMethod + ', to use landscape');
                data.layoutMethod = self.layoutMethod;
                self.layoutMethod = 'landscape'; // force landscape for scalability.
            }

            self.onLayoutReuseUpdateCutoff();
            self.onLayoutPageUpdateCutoff(previous, data.cutoff);
            self.onLayoutPageUpdateNextPrevious();
            self.onLayoutPageUpdateControls();

            // TODO: if data.changeCurrentPage is set, then recalculate currentIndex and currentPage.

            // TODO: update pinnedCount and items displayed in slots.

            // avoid animation for update videos layout here.
            self.disableAnimationOnAllVideos(function () {
                self.updateVideosLayout();
                if (data.layout == 'allhands') {
                    self.onLayoutPageRecalculatePage();
                    self.updateVideosLayout();
                }
            });
        }

        // update current page and index based on new size. caller must call updateVideosLayout after this.
        function onLayoutPageRecalculatePage() {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;

            var videoCount = data.ordered.length;
            var pageCount = Math.ceil(videoCount / data.realSize);
            if (data.anchorFirst) {
                data.currentPage = Math.floor(data.currentIndex / data.realSize);
                if (!data.useSlidingWindow) {
                    data.currentIndex = data.currentPage * data.realSize;
                }
            } else {
                if (data.currentPage >= pageCount) {
                    data.currentPage = pageCount - 1;
                }
                data.currentIndex = data.currentPage * data.realSize;
            }
        }

        // disable animation, invoke callback, re-enable animation.
        function disableAnimationOnAllVideos(callback) {
            $window.$('#videoroom-videos > div[user]').attr('animate', 'false');
            callback();
            $timeout(function () {
                $window.$('#videoroom-videos > div[user]').removeAttr('animate');
            }, 0);
        }

        function getLayoutInputVideos(videoDivs) {
            var data = self.layoutPageData;

            var input = [];
            // determine the input orientations of all videos
            videoDivs.forEach(function (element, index) {
                var item = element.getAttribute('orientation') == 'portrait' ? 'p' : 'l';
                if (element == self.maxvideo) {
                    item = item.toUpperCase();
                }
                input.push(item);
            });

            if (!self.layoutPage) {
                return input;
            }

            // set the order and hide others
            var pausedScreen = self.isVideoTogglePaused(true),
                pausedVideo = self.isVideoTogglePaused(false);

            var fid2index = {};
            var notadded = [];
            var added = [];
            data.slots.forEach(function (fid, index) {
                var item = data.videos[fid];
                if (self.videoToggle && ((pausedScreen && item.content) || (pausedVideo && !item.content))) {
                    notadded.push(fid); // do not add
                } else {
                    added.push(fid);
                    fid2index[fid] = index;
                }
            });
            if (notadded.length > 0) {
                self.logLayout('not added due to videoToggle: ' + notadded.join(','));
            }

            var fid2div = {};
            videoDivs.forEach(function (div, index) {
                var fid = div.getAttribute('user');
                fid2div[fid] = { div: div, data: input[index] };
            });

            added.forEach(function (fid) {
                if (!fid2div[fid]) {
                    if (self.layoutSelfPIP && fid == self.attendantId) {
                        // ignore
                    } else {
                        logger.error('getLayoutInputVideos', 'missing fid in divs but present in slots', fid);
                    }
                }
            });

            var newDivs = added
                .map(function (fid) {
                    return fid2div[fid] ? fid2div[fid].div : null;
                })
                .filter(function (item) {
                    return item != null;
                });

            input = added
                .map(function (fid) {
                    return fid2div[fid] ? fid2div[fid].data : null;
                })
                .filter(function (item) {
                    return item != null;
                });

            var array1 = [0, videoDivs.length].concat(newDivs);
            [].splice.apply(videoDivs, array1);

            var changes = [];
            for (var fid in fid2div) {
                var div1 = fid2div[fid].div;
                // TODO: this needs to be fixed to not set enable to true unless it was reset due to this logic.
                var enable = fid2index[fid] !== undefined;
                div1.setAttribute('enable', enable ? 'true' : 'false');

                if (data.videos[fid]) {
                    var previous = data.videos[fid].visible;
                    if (previous !== enable) {
                        data.videos[fid].visible = enable;
                        changes.push({ fid: fid, value: enable });
                    }
                } else {
                    logger.error(
                        'getLayoutInputVideos',
                        'missing fid in layoutPageData.videos but present in divs',
                        fid
                    );
                }

                // this step is already done before in  updateVideosLayout for disabled video.
                if (!enable) {
                    // since this video is disabled here, need to do here again.
                    div1.setAttribute(
                        'style',
                        'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;'
                    );
                }
            }

            self.onLayoutPageVideoChanges(changes, 'layout');

            // Do not remove, enable for local debugging.
            if (added.length !== data.slots.length) {
                self.logLayout('getLayoutInputVideos() added=' + added.join(','));
            } else {
                self.logLayout('getLayoutInputVideos() slots=' + data.slots.join(','));
            }

            return input;
        }

        function getLayoutPageAllHands(videoDivs, input, W, H, ratio1, ratio2) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;

            // determine the best rows R and columns C such that RxC <= desited page size but as close,
            // and individual videas within ratio, but closer to ratio1.

            var P = data.pageSize;
            var items = [],
                nonitems = [];
            for (var i = 1; i <= P; ++i) {
                // row
                for (var j = 1; j <= P; ++j) {
                    // column
                    if (i * j <= P) {
                        var w0 = W / j,
                            h0 = H / i;
                        var r = w0 / h0;
                        var item = { R: i, C: j, nd: P - i * j, rd: data.preferSquare ? r - ratio2 : ratio1 - r };
                        if (r <= ratio1 && r >= ratio2) {
                            // assume landscape
                            items.push(item);
                        } else {
                            nonitems.push(item);
                        }
                    }
                }
            }

            if (!data.flexibleCount) {
                // keep count at P.
                items = items.filter(function (item) {
                    return item.R * item.C == P;
                });
                if (!items.length) {
                    items = nonitems.filter(function (item) {
                        return item.R * item.C == P;
                    });
                }
                items.forEach(function (item) {
                    // calculate area also, may cause empty padding.
                    var w = W / item.C,
                        h = H / item.R;
                    var r = w / h;
                    if (r < ratio2) {
                        h = w / ratio2;
                    } else if (r > ratio1) {
                        w = h * ratio1;
                    }
                    item.area = w * h;
                });
                items.sort(function (a, b) {
                    // use area to sort the best layout
                    return b.area - a.area;
                });
            } else {
                // allow lower count, as long as it fills everything.
                items.sort(function (a, b) {
                    return a.nd != b.nd ? a.nd - b.nd : a.rd - b.rd;
                });
            }

            var R, C;
            if (items.length > 0) {
                R = items[0].R;
                C = items[0].C;
            } else {
                // need a fallback strategy
                self.logLayout('could not find a valid layout, so assuming sqrt of ' + P);
                R = C = Math.floor(Math.sqrt(P)); // assume R == C
            }

            var w = W / C;
            var h = H / R;
            var x1 = 0,
                y1 = 0;
            if (w / h > ratio1 || w / h < ratio2) {
                // adjust
                if (w / h > ratio1) {
                    // too wide, reduce width.
                    w = h * ratio1;
                    x1 = W / 2 - (w * C) / 2;
                } else {
                    // too tall, reduce height
                    h = w / ratio2;
                    y1 = H / 2 - (h * R) / 2;
                }
            }

            data.rows = R;
            data.columns = C;
            var RC = (data.realSize = R * C); // actual page size after calculation, may be lower than desired page size.

            var removed = [];

            // optimize this by keeping sorted list. i.e., always use ordered in the else part.
            if (!data.alwaysUseOrdered && data.addOnCurrentPage && data.includeContentVideo && data.includeSelfVideo) {
                self.logLayout('sorting videoDivs by name');
                videoDivs.sort(function (a, b) {
                    return a.sortName < b.sortName ? -1 : a.sortName > b.sortName ? 1 : 0;
                });
            } else {
                // use data.ordered to build this.
                self.logLayout('using ordered list for videoDivs');
                videoDivs.splice(0, videoDivs.length);
                data.ordered.forEach(function (fid) {
                    var item = data.videos[fid];
                    videoDivs.push(item.div);
                });
                if (!data.includeContentVideo || !data.includeSelfVideo) {
                    for (var fid2 in data.videos) {
                        var item2 = data.videos[fid2];
                        if ((item2.content && !data.includeContentVideo) || (item2.self && !data.includeSelfVideo)) {
                            removed.push(item2.div);
                        }
                    }
                }
            }

            var index0 = data.currentIndex; // or data.currentPage * RC;
            var index1 = data.currentIndex + RC; // or (data.currentPage + 1) * RC;

            self.logLayout('showing index ' + index0 + ' to ' + index1 + ' first: ' + data.ordered[index0]);

            var videoCount = data.ordered.length;
            if (index1 < videoCount) {
                removed = removed.concat(videoDivs.splice(index1, videoCount - index1));
            }
            if (index0 > 0) {
                removed = removed.concat(videoDivs.splice(0, index0));
            }

            self.onLayoutPageUpdateNextPrevious();

            if (input.length) {
                input.splice(0, input.length);
            }
            videoDivs.forEach(function (element, index) {
                var item = element.getAttribute('orientation') == 'portrait' ? 'p' : 'l';
                input.push(item);
            });

            videoDivs.forEach(function (div1) {
                div1.setAttribute('enable', 'true');
            });
            removed.forEach(function (div1) {
                div1.setAttribute('enable', 'false');
                div1.setAttribute(
                    'style',
                    'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;'
                );
            });

            // assume data.ordered is correct, same order as videoDivs now.
            var changes = [];
            for (var m = 0; m < data.ordered.length; ++m) {
                var fid1 = data.ordered[m];
                var enable = m >= index0 && m < index1;
                var previous = data.videos[fid1].visible;
                if (previous != enable) {
                    data.videos[fid1].visible = enable;
                    changes.push({ fid: fid1, value: enable });
                }
            }
            self.onLayoutPageVideoChanges(changes, 'allhands');

            var round = function (value) {
                return Math.round(value * 10) / 10;
            };
            var k = 0;
            var N = input.length;
            var output = [];
            for (var y = 0; y < R && k < N; ++y) {
                for (var x = 0; x < C && k < N; ++x, ++k) {
                    output.push({ x: round(x1 + x * w), y: round(y1 + y * h), w: round(w), h: round(h) });
                }
            }

            self.logLayout(
                'allhands layout with ' +
                    output.length +
                    ' videos, real size=' +
                    data.realSize +
                    ' row=' +
                    R +
                    ' columns=' +
                    C
            );
            return output;
        }

        function isLayoutPageVideoExpandable(div) {
            return !(
                self.layoutPage &&
                !self.layoutPageData.includeSelfVideo &&
                div.getAttribute('user') == self.attendantId
            );
        }

        function addLayoutVideoItem(fid, div) {
            if (!self.layoutPin && !self.layoutPage) {
                return;
            }

            var isPinned = self.layoutPin ? self.getLayoutPinnedForAttendee(fid) : false;

            var data = self.layoutPageData;

            if (!data.includeSelfVideo && fid == self.attendantId) {
                self.logLayout('not adding self video to layout');
                return;
            }

            if (data.showPinnedLabel) {
                if (isPinned) {
                    div.setAttribute('pinned', 'true');
                } else {
                    div.removeAttribute('pinned');
                }
            }

            if (!self.layoutPage) {
                self.logLayout('addLayoutVideoItem() fid=' + fid + ' pinned=' + isPinned);
                return;
            }

            if (data.videos[fid] !== undefined) {
                logger.warn('addLayoutVideoItem', 'video already exists for fid', fid);
                return;
            }

            //before, we used to set the video item visible setting to "true" and explicity set it "false" for
            // all hands view (awv, lgv).  Now we set this to false and allow other code to set it's visibility to true as appropriate
            var item = (data.videos[fid] = {
                visible: false,
                fid: fid,
                self: fid == self.attendantId,
                content: self.isScreenshareId(fid),
                pinned: isPinned,
                tsTalker: 0,
                tsSilent: 0,
                tsSlotted: 0,
                tsUnslotted: 0,
                sortName: div.sortName,
                div: div
            });

            self.logLayout(
                'addLayoutVideoItem() fid=' +
                    fid +
                    ' data=' +
                    JSON.stringify(Object.assign({}, item, { div: undefined }))
            );

            data.videoCount++; // one more video
            if (item.self && data.includeSelfVideo) {
                data.hasSelf = true;
            }

            if ((data.includeSelfVideo || !item.self) && (data.includeContentVideo || !item.content)) {
                var videoCount = data.ordered.length + 1; // assume one is added.
                if (data.layout != 'allhands' || data.addOnCurrentPage) {
                    self.logLayout('append to ordered list in sorted');
                    for (var i = 0; i <= data.ordered.length; ++i) {
                        var ofid = data.ordered[i];
                        if (ofid === undefined || item.sortName < data.videos[ofid].sortName) {
                            if (ofid === undefined) {
                                data.ordered.push(fid);
                            } else {
                                data.ordered.splice(i, 0, fid);
                            }

                            if (
                                data.layout == 'allhands' &&
                                i <= data.currentIndex &&
                                !data.changeCurrentPage &&
                                data.currentIndex < videoCount - 1
                            ) {
                                data.currentIndex++; // so that existing allhands view is not changed.
                            }
                            self.logLayout('addLayoutVideoItem() data.currentIndex:' + data.currentIndex);
                            break;
                        }
                    }
                } else {
                    // append, and will be sorted later.
                    self.logLayout('append to ordered list without sorting');
                    data.ordered.push(fid);
                }
            }

            var slotted = true;

            if (!item.self && item.pinned && data.pinnedCount < data.cutoff - data.pinnedFree) {
                self.logLayout('videoPageLayoutService->addLayoutVideoItem() set layoutPin of video, fid=' + fid);
                self.setLayoutPinOfVideo(fid);
            } else if (data.videoCount <= data.cutoff) {
                if (self.layoutOrder && self.layoutOrder != 'id') {
                    // name. insert and sort. ignore supplied position. ignore layoutOrder=id,
                    self.logLayout('has layoutOrder=' + self.layoutOrder);
                    data.slots.push(fid);
                    self.onLayoutPageOrderedSlots();
                } else {
                    // do not use supplied position.
                    if (
                        !item.self &&
                        data.slots.length > 0 &&
                        data.videos[data.slots[data.slots.length - 1]] &&
                        data.videos[data.slots[data.slots.length - 1]].self
                    ) {
                        // append before last self.
                        self.logLayout('insert before the last');
                        data.slots.splice(data.slots.length - 1, 0, fid);
                    } else {
                        self.logLayout('append at the end');
                        data.slots.push(fid);
                    }
                }
            } else {
                // do not use position
                if (self.layoutOrder && self.layoutOrder != 'id' && (item.self || item.content)) {
                    var fid3 = self.getLayoutPageRandomSlot();
                    if (fid3) {
                        var index3 = data.slots.indexOf(fid3);
                        data.slots.splice(index3, 1, fid);
                        self.logLayout('replace random slot index=' + index3 + ' fid=' + fid3);
                        self.setLayoutPageVideoSlotted(fid3, false);
                        self.onLayoutPageOrderedSlots();
                    } else {
                        self.logLayout('could not find a slot to replace new fid=' + fid);
                        slotted = false;
                    }
                } else if (item.self) {
                    self.logLayout('append at the end, more than cutoff');
                    data.slots.push(fid);

                    if (data.slots.length > data.cutoff) {
                        // remove an item with oldest ts. search backward from end.
                        self.onLayoutPageRemoveOneSlot('backward');
                    }
                } else if (item.content) {
                    // content is preferred in slots.
                    var fid1 = self.getLayoutPageRandomSlot();
                    if (!fid1 && data.preferContentOverTalker) {
                        self.logLayout('failed to find a slot, so retrying without talker check');
                        fid1 = self.getLayoutPageRandomSlot(true);
                    }
                    if (fid1) {
                        var index1 = data.slots.indexOf(fid1);
                        self.logLayout('add content at random slot index=' + index1 + ' fid=' + fid1);
                        data.slots.splice(index1, 1, fid);
                        self.setLayoutPageVideoSlotted(fid1, false);

                        // // TODO: no flip effect cane done here.
                        // // it interferes with the updateVideosLayout called later.
                        // if (data.layout != 'allhands') {
                        //     self.flipVideoLayout(fid1, fid);
                        // }
                    } else if (data.preferContentOverTalker) {
                        self.logLayout('append content after pinned, more than cutoff');
                        data.slots.splice(data.pinnedCount, 0, fid);

                        if (data.slots.length > data.cutoff) {
                            self.onLayoutPageRemoveOneSlot('forwardplus');
                        }
                        slotted = true;
                    } else {
                        self.logLayout('could not find a slot to replace fid=' + fid);
                        slotted = false;
                    }
                } else {
                    // else no need to put in slots unless it becomes a talker.
                    self.logLayout('do not add to slots');
                    slotted = false;
                }
            }

            if (slotted) {
                self.setLayoutPageVideoSlotted(fid, true);
            }

            if (data.slots.length > data.cutoff) {
                logger.warn(
                    'addLayoutVideoItem',
                    'logic error in removing slots item beyond cutoff, ' + data.slots.length + ' > ' + data.cutoff
                );
            }

            if (data.videoCount == data.cutoff + 1) {
                // start a thread to periodically flip random videos.
                self.startLayoutPageFlipTask();
            }

            //self.logLayout('slots=' + data.slots.join(',')); // do not remove
        }

        function removeLayoutVideoItem(fid, div) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            var item = data.videos[fid];
            if (item === undefined) {
                // not present already;
                self.logLayout('ignoring remove video item as not found, fid=' + fid);
                return;
            }

            self.logLayout('removeLayoutVideoItem() fid=' + fid);

            delete data.videos[fid];
            data.videoCount--;

            var index1 = data.ordered.indexOf(fid);
            var videoCount = data.ordered.length;
            if (index1 >= 0) {
                data.ordered.splice(index1, 1);
                videoCount--;
                if (
                    data.layout == 'allhands' &&
                    index1 <= data.currentIndex &&
                    data.currentIndex < videoCount &&
                    !data.changeCurrentPage &&
                    data.currentIndex > 0
                ) {
                    data.currentIndex--; // so that view is not changed. do not adjust currentPage yet.
                }
            }
            if (data.layout == 'allhands') {
                if (videoCount == 0) {
                    self.logLayout('resetting index=' + data.currentIndex + ' page=' + data.currentPage);
                    data.currentIndex = data.currentPage = 0;
                } else if ((data.changeCurrentPage || data.useSlidingWindow) && data.currentIndex >= videoCount) {
                    // move back one page.
                    data.currentIndex = Math.max(0, data.currentIndex - data.realSize);
                    data.currentPage = Math.floor(data.currentIndex / data.realSize);
                    self.logLayout('changing sliding, page=' + data.currentPage + ' index=' + data.currentIndex);
                } else if (data.currentIndex >= videoCount) {
                    // go to last page.
                    var pageCount = Math.ceil(videoCount / data.realSize);
                    data.currentPage = Math.max(0, pageCount - 1);
                    data.currentIndex = data.currentPage * data.realSize;
                    self.logLayout('changing, index=' + data.currentIndex + ' page=' + data.currentPage);
                }
                self.onLayoutPageUpdateNextPrevious();
            }

            var index = data.slots.indexOf(fid);
            if (index >= 0) {
                self.logLayout('removing from slots index=' + index);
                data.slots.splice(index, 1);
                self.setLayoutPageVideoSlotted(fid, false);
            }
            if (item.self && data.hasSelf) {
                data.hasSelf = false;
            }
            if (item.pinned && index >= 0 && !item.self) {
                self.logLayout('decrementing pinnedCount=' + data.pinnedCount + '-1');
                data.pinnedCount--;
            }
            // do not remove from data.pinned.
            // TODO: remove from pendingFlips if destination.

            if (data.videoCount == data.cutoff) {
                // stop the thread to periodically flip random videos.
                self.stopLayoutPageFlipTask();
            }

            if (index >= 0) {
                // removed from data.slots, fill it again if needed.
                if (data.slots.length < data.cutoff && data.videoCount > data.slots.length) {
                    var userandom = true; // whether to pick random
                    if (item.pinned && data.pinnedCount == data.cutoff - data.pinnedFree - 1) {
                        // check if another pinned exists that can be used to replace.
                        var keys = Object.keys(data.videos);
                        keys = keys.filter(function (fid) {
                            return data.videos[fid].pinned && data.slots.indexOf(fid) < 0;
                        });
                        if (keys.length > 0) {
                            // pick a random, instead of other values.
                            var newfid = keys[Math.floor(Math.random() * keys.length)];
                            self.logLayout('filling pinned from fid=' + newfid);
                            data.setLayoutPinOfVideo(newfid);
                            userandom = false; // no need to pick random
                        }
                    }
                    if (userandom) {
                        // find anything else to replace.
                        var newfid1 = self.getLayoutPageRandomUnslot();
                        if (newfid1 !== null && newfid1 !== undefined) {
                            if (!item.pinned) {
                                // replace at that slot
                                self.logLayout('replacing with fid=' + newfid1);
                                data.slots.splice(index, 0, newfid1);
                            } else {
                                // replace at end of pinned
                                self.logLayout('replacing pinned with fid=' + newfid1);
                                data.slots.splice(data.pinnedCount, 0, newfid1);
                            }

                            self.setLayoutPageVideoSlotted(newfid1, true);

                            if (self.layoutOrder && self.layoutOrder != 'id') {
                                self.onLayoutPageOrderedSlots();
                            }
                        } else {
                            self.logLayout('not replacing, as no unslotted video found');
                        }
                    }
                } else {
                    self.logLayout('no need to fill the removed slot');
                }
            }
        }

        // perform any animation if needed for removing.
        function onLayoutPageRemoving(div, callback) {
            if (
                !self.layoutPage ||
                !self.layoutPageData.animateRemove ||
                helperService.getIsMeetingEnding() ||
                !div ||
                $window.$(div).hasClass('local') ||
                div.getAttribute('animate') == 'false' ||
                self.conferenceLeft ||
                (!self.hasTestLayout && !self.janus)
            ) {
                // no animation.
                callback();
            } else {
                self.logLayout('animate video remove for fid=' + div.getAttribute('user'));
                // fade out
                div.removeAttribute('user'); // this prevents using the item in app logic.
                div.setAttribute('removing', 'true'); // changes opacity to 0 over 0.3s
                $timeout(function () {
                    callback();
                }, 300);
            }
        }

        // sort the slots after pinned videos.
        function onLayoutPageOrderedSlots() {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            var slots = data.slots.splice(data.pinnedCount, data.slots.length - data.pinnedCount);
            slots.sort(function (a, b) {
                var an = data.videos[a].sortName,
                    bn = data.videos[b].sortName;
                return an < bn ? -1 : an > bn ? 1 : 0;
            });
            slots.forEach(function (fid) {
                data.slots.push(fid);
            });
            self.logLayout('onLayoutPageOrderedSlots() slots=' + data.slots.join(','));
        }

        function onLayoutPageFlip(fid) {
            if (!self.layoutPage) {
                return;
            }

            self.logLayout('onLayoutPageFlip() fid=' + fid);
            var data = self.layoutPageData;
            var index = -1;
            if (fid == 'random') {
                fid = self.getLayoutPageRandomSlot();
                if (!fid) {
                    self.logLayout('cannot flip random video, none available to be flipped');
                    return;
                }
            }
            index = data.slots.indexOf(fid);

            if (index < 0 || data.videoCount <= data.cutoff) {
                logService.log(
                    'videoroomCtrl - failed to find video to flip or not enough, id=' +
                        fid +
                        ' count=' +
                        data.videoCount
                );
                return;
            }

            var newfid = self.getLayoutPageRandomUnslot();
            if (newfid !== null && newfid !== undefined) {
                self.logLayout('flipping fid ' + fid + ' with ' + newfid + ' at index=' + index);
                data.slots.splice(index, 1, newfid);
                self.setLayoutPageVideoSlotted(fid, false);
                self.setLayoutPageVideoSlotted(newfid, true);

                var update = false; // if true, do not flip.
                if (data.layout == 'spotlight' && data.videos[fid].div == self.maxvideo) {
                    // previously spotlighted, then
                    self.onLayoutPageToggleSpotlight(data.videos[newfid].div);
                    update = true;
                }

                if (update || (self.layoutOrder && self.layoutOrder != 'id')) {
                    if (self.layoutOrder && self.layoutOrder != 'id') {
                        self.onLayoutPageOrderedSlots();
                    }
                    if (!data.animateChange) {
                        self.disableAnimationOnAllVideos(function () {
                            self.updateVideosLayout();
                        });
                    } else {
                        self.updateVideosLayout();
                    }
                } else {
                    // TODO: do not call updateVideosLayout. Manually flip with animation here.
                    // self.updateVideosLayout();

                    if (data.layout != 'allhands') {
                        // no flip in allhands
                        // do not remove, needed for testing.
                        // data.videos[newfid].div.querySelector('div.testlayout').style.webkitFilter = 'blur(5px)';
                        self.flipVideoLayout(fid, newfid);
                    } else {
                        self.logLayout('do not animate flip in allhands');
                    }
                }
            } else {
                self.logLayout('cannot flip, as new fid is not found, fid=' + fid + ', newfid=' + newfid);
            }
        }

        // must not call updateVideosLayout in this function.
        function flipVideoLayout(fid0, fid1) {
            if (!self.layoutPage || fid0 == fid1) {
                return;
            }

            var data = self.layoutPageData;

            self.logLayout('flipVideoLayout() ' + fid0 + ',' + fid1);

            data.videos[fid0].visible = false;
            data.videos[fid1].visible = true;
            var changes = [
                { fid: fid0, value: false },
                { fid: fid1, value: true }
            ];
            self.onLayoutPageVideoChanges(changes, 'flip');

            var div0 = data.videos[fid0].div,
                div1 = data.videos[fid1].div;
            div0.setAttribute('enable', 'false');
            div1.setAttribute('enable', 'true');

            if (!data.animateFlip) {
                self.processFlipNoAnimate(div0, div1);
                div0.setAttribute(
                    'style',
                    'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;'
                );
            } else {
                data.pendingFlips.push([fid0, fid1]);
                if (data.pendingFlips.length == 1) {
                    self.processNextPendingFlip();
                } else {
                    self.logLayout('putting to pending flip list');
                }
            }
        }

        function processFlipNoAnimate(div0, div1) {
            div1.style.left = div0.style.left;
            div1.style.top = div0.style.top;
            div1.style.width = div0.style.width;
            div1.style.height = div0.style.height;
            div1.style.display = div0.style.display;
            div1.style.visibility = div0.style.visibility;

            // TODO: assumes layoutMethod is landscape. use other logic instead.
            // add black border on sides for portrait videos.
            if (div1.getAttribute('orientation') == 'portrait') {
                var w = parseInt(div1.style.width);
                var h = parseInt(div1.style.height);
                // round to one decimal digit.
                var round = function (value) {
                    return Math.round(value * 10) / 10;
                };
                if (w > h) {
                    var border = w / 2 - h / 2 - 2.0; // offset to avoid thin background line
                    div1.style.borderLeftWidth = round(border) + 'px';
                    div1.style.borderRightWidth = round(border) + 'px';
                }
            }

            self.layoutPageResetSrcObjectIfNeeded(div0);
        }

        // must be called when pendingFlips has 1 or more items.
        function processNextPendingFlip() {
            var data = self.layoutPageData;
            if (data.pendingFlips.length == 0) {
                if (data.updateAfterFlip) {
                    // if update was needed after flip, run it.
                    var updateType = data.updateAfterFlip;
                    delete data.updateAfterFlip;
                    if (updateType == 'noanimate') {
                        self.disableAnimationOnAllVideos(function () {
                            self.updateVideosLayout();
                        });
                    } else {
                        self.updateVideosLayout();
                    }
                }
                return;
            }

            var next = data.pendingFlips[0];
            var fid0 = next[0],
                fid1 = next[1];

            var item0 = data.videos[fid0],
                item1 = data.videos[fid1];
            if (!item0 || !item1) {
                self.logLayout('flip layout video failed, as item no longer exists ' + !!item0 + ',' + !!item1);
                data.pendingFlips.shift();
                self.processNextPendingFlip();
                return;
            }

            var div0 = item0.div,
                div1 = item1.div;

            if (!data.animateAllFlips && data.updateAfterFlip) {
                // avoid animating more flips.
                self.processFlipNoAnimate(div0, div1);

                div0.setAttribute(
                    'style',
                    'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;'
                );

                self.logLayout('flipping ' + fid0 + ' to ' + fid1 + ' without animation');

                data.pendingFlips.shift();
                self.processNextPendingFlip();
                return;
            }

            self.logLayout('flipping ' + fid0 + ' to ' + fid1);

            // animate rotate div0
            $('#videoroom-videos').css('perspective', '2000px');
            var transition = 'transform ' + data.flipDuration / 2000 + 's linear';
            div0.style.zIndex = 2;
            div0.style.transition = transition;
            div0.style.transform = 'rotateY(90deg)';
            $timeout(function () {
                // show div1, hide 0, animate rotate div1
                //div1.setAttribute('style', div0.getAttribute('style')); // copy position, and visibility. does not work, as it copies border-left|right-width too. copy individually.

                self.processFlipNoAnimate(div0, div1);

                div1.style.zIndex = 2;
                div0.style.display = 'none';
                div0.style.visibility = 'hidden';
                div0.style.transition = '';
                div0.style.zIndex = div0.style.transform = '';
                div0.style.left = div0.style.top = div0.style.width = div0.style.height = '0px';
                div1.style.transform = 'rotateY(-90deg)';
                div1.style.transition = transition;
                $timeout(function () {
                    div1.style.transform = 'rotateY(0deg)';
                }, 0);
                $timeout(function () {
                    // remove temp styles
                    div1.style.transition = '';
                    div1.style.zIndex = div1.style.transform = '';
                    $('#videoroom-videos').css('perspective', '');

                    data.pendingFlips.shift();
                    self.processNextPendingFlip();
                }, Math.round(data.flipDuration / 2));
            }, Math.round(data.flipDuration / 2));
        }

        function onLayoutPageToggleFlip() {
            if (!self.layoutPage || self.isCompactMode) {
                return;
            }

            var data = self.layoutPageData;
            if (data.videoCount > data.cutoff) {
                if (data.flipTimer) {
                    self.logLayout('stopping periodic flip task');
                    $interval.cancel(data.flipTimer);
                    data.flipTimer = null;
                } else {
                    self.logLayout('starting periodic flip task at 5s interval');
                    data.flipTimer = $interval(function () {
                        self.onLayoutPagePeriodicFlip(1);
                    }, 5000); // reduce to small interval and one flip for testing
                }
            } else {
                // cannot enable toggle
                self.logLayout('ignoring layout page toggle flip, count=' + data.videoCount + ' <= ' + data.cutoff);

                if (data.flipTimer) {
                    $interval.cancel(data.flipTimer);
                    data.flipTimer = null;
                }
            }
        }

        function startLayoutPageFlipTask() {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;
            if (!data.flipTimer) {
                self.logLayout('starting periodic flip task');
                data.flipTimer = $interval(function () {
                    self.onLayoutPagePeriodicFlip();
                }, data.flipInterval);
            }
        }

        function stopLayoutPageFlipTask() {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;
            if (data.flipTimer) {
                self.logLayout('stopping periodic flip task');
                $interval.cancel(data.flipTimer);
                data.flipTimer = null;
            }
        }

        function onLayoutPagePeriodicFlip(bucketSize) {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;
            if (data.layout == 'allhands') {
                // no change and no flip
                self.logLayout('no need for flip in allhands');
                return;
            }
            self.logLayout('onLayoutPagePeriodicFlip() bucketSize=' + bucketSize);
            // avoid duplicate, if less possible videos flippable.
            // get list of fids that flipped, even if less than bucketSize.
            var flipped = [];
            var callUpdateLayout = function () {
                // needed to avoid a warning.
                self.updateVideosLayout();
            };
            for (var i = 0; i < (bucketSize || data.flipBucketSize); ++i) {
                var oldfid = self.getLayoutPageRandomSlot();
                var newfid = self.getLayoutPageRandomUnslot();
                if (
                    oldfid &&
                    newfid !== null &&
                    newfid !== undefined &&
                    flipped.indexOf(oldfid) < 0 &&
                    flipped.indexOf(newfid) < 0
                ) {
                    flipped.push(oldfid);
                    flipped.push(newfid);
                    var index = data.slots.indexOf(oldfid);
                    self.logLayout('selected to flip ' + oldfid + ' with ' + newfid + ' at index=' + index);
                    data.slots.splice(index, 1, newfid);
                    self.setLayoutPageVideoSlotted(oldfid, false);
                    self.setLayoutPageVideoSlotted(newfid, true);

                    if (self.layoutOrder && self.layoutOrder != 'id') {
                        self.onLayoutPageOrderedSlots();
                        if (!data.animateChange) {
                            self.disableAnimationOnAllVideos(callUpdateLayout);
                        } else {
                            self.updateVideosLayout();
                        }
                    } else {
                        self.flipVideoLayout(oldfid, newfid);
                    }
                } else {
                    self.logLayout('no new fid found to flip or no slot found in existing.  aborting flip');
                    break;
                }
            }
        }

        function onLayoutPageToggleTalker() {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;
            if (data.randomTalkerTimer) {
                self.logLayout('stopping random talker task');
                $interval.cancel(data.randomTalkerTimer);
                data.randomTalkerTimer = null;
            } else {
                self.logLayout('starting random talker task');
                data.randomTalkerTimer = $interval(function () {
                    self.onLayoutPageRandomTalker();
                }, data.randomTalkerInterval);
                self.onLayoutPageRandomTalker();
            }
        }

        function setVideoTalking(div, value) {
            if (value && !div.hasAttribute('talking')) {
                div.setAttribute('talking', 'true');
            } else if (!value && div.hasAttribute('talking')) {
                div.removeAttribute('talking');
            }

            if (!self.layoutPage) {
                // rest of the processing is only for layoutPage.
                return;
            }

            var data = self.layoutPageData;
            var fid = div.getAttribute('user');
            var item = data.videos[fid];
            if (item) {
                if (value) {
                    item.tsTalker = Date.now(); // started talking
                } else {
                    item.tsSilent = Date.now(); // stopped talking
                }
            }
        }

        function setLayoutPageVideoSlotted(fid, value) {
            if (!self.layoutPage) {
                // rest of the processing is only for layoutPage.
                return;
            }

            var data = self.layoutPageData;
            var item = data.videos[fid];
            if (item) {
                if (value) {
                    item.tsSlotted = Date.now();
                } else {
                    item.tsUnslotted = Date.now();
                }
            } else {
                self.logLayout(
                    `videoLayoutPageService.setPageVideoSlotted: missing data.video with fid: ${fid}, value: ${value}`
                );
            }
        }

        function isLayoutPageRecentTalker(fid, now) {
            if (!now) {
                // minor optimization to have caller pass current time.
                now = Date.now();
            }
            var data = self.layoutPageData;
            var item = data.videos[fid];
            return (
                item.tsTalker &&
                (!item.tsSilent || item.tsSilent < item.tsTalker || item.tsSilent >= now - data.talkerDuration)
            );
        }

        function onLayoutPageRemoveOneSlot(type) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;

            var forward = type != 'backward';

            self.logLayout('onLayoutPageRemoveOneSlot() type=' + type);

            var oindex = forward ? data.pinnedCount : data.slots.length - 2;
            if (type == 'forwardplus') {
                oindex++;
            }
            var ofid = data.slots[oindex];
            var oldest = data.videos[ofid];
            var now = Date.now();
            for (
                var i = forward ? data.pinnedCount + 1 : oindex;
                oldest.tsSlotted && ((forward && i < data.slots.length) || (!forward && i >= data.pinnedCount));
                forward ? ++i : --i
            ) {
                var fid = data.slots[i];
                var item1 = data.videos[fid];
                // if previous is a talker but new is not, or
                // if new is not a talker and slotted before previous.
                // do not use self or content.
                if (
                    !self.isLayoutPageRecentTalker(fid) &&
                    !item1.self &&
                    !item1.content &&
                    (self.isLayoutPageRecentTalker(ofid, now) ||
                        oldest.self ||
                        oldest.content ||
                        (oldest.tsSlotted && (!item1.tsSlotted || item1.tsSlotted < oldest.tsSlotted)))
                ) {
                    // absorb multiple slotted witin a second.
                    oldest = item1;
                    oindex = i;
                }
            }
            ofid = data.slots[oindex];
            if (forward) {
                self.logLayout('remove at index=' + oindex + ' fid=' + ofid);
                data.slots.splice(oindex, 1); // remove at selected index
            } else {
                // should avoid movement, swap instead of splice.
                if (oindex < data.slots.length - 1) {
                    var fid1 = data.slots[data.slots.length - 2]; // last swappable one
                    self.logLayout('remove at index=' + oindex + ' fid=' + ofid + ', swap ' + fid1 + ' with last');
                    data.slots.splice(data.slots.length - 2, 1);
                    data.slots.splice(oindex, 1, fid1);
                } else {
                    self.logLayout('remove at index=' + oindex + ' fid=' + ofid + ', nothing to swap');
                    data.slots.splice(oindex, 1);
                }
            }
            self.setLayoutPageVideoSlotted(ofid, false);
        }

        // similar to updateTalkerLayout, but only for testlayout case.
        function onLayoutPageRandomTalker(onlyFromSlots) {
            if (!self.layoutPage || !self.hasTestLayout) {
                return;
            }

            var data = self.layoutPageData;

            var keys = onlyFromSlots ? data.slots : Object.keys(data.videos);
            var index = Math.floor(Math.random() * keys.length);
            var fid = keys[index];
            var item = data.videos[fid];
            var div = item.div;

            self.logLayout('onLayoutPageRandomTalker() onlyFromSlots=' + onlyFromSlots + ' selected fid=' + fid);

            self.setVideoTalking(div, true);

            // schedule to remove talker.
            if (div.removeTalkingTimer) {
                $timeout.cancel(div.removeTalkingTimer);
                delete div.removeTalkingTimer;
            }
            // talking duration.
            var timeout = Math.round(
                data.randomTalkerInterval - data.randomTalkerVariance / 2 + data.randomTalkerVariance * Math.random()
            );
            div.removeTalkingTimer = $timeout(function () {
                self.logLayout('remove random talking for fid=' + fid);
                delete div.removeTalkingTimer;
                self.setVideoTalking(div, false);
            }, timeout);

            // put to slots if not already there.
            if (!onlyFromSlots) {
                if (self.onLayoutPageUpdateTalker(fid) === false) {
                    return; // no slot found to bring it in.
                }
            }

            // see updateTalkerLayout for details.
            if (
                data.layout != 'allhands' &&
                (self.talkerLayout == 'spotlight' ||
                    (self.talkerLayout == 'auto' && !self.hasScreenDisplay && !!self.maxvideo)) &&
                div != self.maxvideo
            ) {
                var previousMaxVideo = self.maxvideo;
                $timeout(function () {
                    if (self.maxvideo == previousMaxVideo) {
                        // do not change if maxvideo already changed during this time.
                        self.onLayoutPageToggleSpotlight(div);
                        self.updateVideosLayout();
                    }
                }, 1000);
            }
        }

        function onLayoutPageUpdateTalker(fid) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;

            if (!data.videos[fid]) {
                // it means update talker was called after div was removed, race condition.
                logger.error('onLayoutPageUpdateTalker', 'detected missing video with id', fid);
                return false;
            }

            // if not in slots, then bring in the slots first.
            if (data.slots.indexOf(fid) < 0) {
                self.logLayout('update talker fid=' + fid + ' is not in slots, bringing in');
                var oldfid = self.getLayoutPageRandomSlot();
                if (oldfid) {
                    if (!data.videos[oldfid]) {
                        logger.error(
                            'onLayoutPageUpdateTalker',
                            'detected missing video in layoutPageRandomSlot with id',
                            oldfid
                        );
                        return false;
                    }

                    var index2 = data.slots.indexOf(oldfid);
                    self.logLayout('putting to slots at index=' + index2 + ' replacing fid=' + oldfid);
                    data.slots.splice(index2, 1, fid);
                    self.setLayoutPageVideoSlotted(oldfid, false);
                    self.setLayoutPageVideoSlotted(fid, true);

                    if (self.layoutOrder && self.layoutOrder != 'id') {
                        self.onLayoutPageOrderedSlots();
                        if (data.layout != 'allhands') {
                            if (!data.animateChange) {
                                self.disableAnimationOnAllVideos(function () {
                                    self.updateVideosLayout();
                                });
                            } else {
                                self.updateVideosLayout();
                            }
                        }
                    } else {
                        if (data.layout != 'allhands') {
                            self.flipVideoLayout(oldfid, fid);
                        }
                    }
                } else {
                    self.logLayout('cannot find a slot to replace with new talker fid=' + fid);
                    return false;
                }
            }
            return;
        }

        // return a random slot, preferably one which is not recent talker or pinned or self or content or maxvideo.
        // any code that uses this function must be prepared to receive null or undefined.
        function getLayoutPageRandomSlot(ignoreTalker) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            var fid = null;
            var now = Date.now();
            var items = data.slots
                .filter(function (fid, index) {
                    var item = data.videos[fid];
                    if (!item) {
                        self.logLayout(
                            'no item found for fid=' + fid + ', ' + JSON.stringify(Object.keys(data.videos))
                        );
                        return false;
                    }
                    // do not use item.pinned below.
                    return (
                        index >= data.pinnedCount &&
                        !item.content &&
                        !item.self &&
                        item.div != self.maxvideo &&
                        (ignoreTalker || !self.isLayoutPageRecentTalker(fid, now))
                    );
                })
                .sort(function (a, b) {
                    var t1 = data.videos[a].tsSilent,
                        t2 = data.videos[b].tsSilent;
                    return (t1 < now - data.talkerHistory ? 0 : t1) - (t2 < now - data.talkerHistory ? 0 : t2); // TODO: need separate thread to cleanup tsSilent
                });

            if (items.length > 0) {
                var ts0 = data.videos[items[0]].tsSilent;
                items = items
                    .filter(function (fid) {
                        var t1 = data.videos[fid].tsSilent;
                        return (
                            Math.abs(
                                (t1 < now - data.talkerHistory ? 0 : t1) - (ts0 < now - data.talkerHistory ? 0 : ts0)
                            ) < 1000
                        );
                    })
                    .sort(function (a, b) {
                        // if multiple use oldest slotted too.
                        return data.videos[a].tsSlotted - data.videos[b].tsSlotted;
                    });
                var ts1 = data.videos[items[0]].tsSlotted;
                items = items.filter(function (fid) {
                    return Math.abs(data.videos[fid].tsSlotted - ts1) < 1000; // slotted within 1 seconds.
                });
                fid = items[Math.floor(Math.random() * items.length)]; // random if multiple
                //fid = items[0]; // oldest slotted.
            }
            self.logLayout('getLayoutPageRandomSlot() => ' + fid);
            return fid;
        }

        function getLayoutPageRandomUnslot() {
            if (!self.layoutPage) {
                return null;
            }

            var data = self.layoutPageData;
            var newfid = null;
            var keys = Object.keys(data.videos);
            // TODO: need some data structures to optimize this.
            if (keys.length > 0) {
                keys = keys
                    .filter(function (fid) {
                        return data.slots.indexOf(fid) < 0;
                    })
                    .sort(function (a, b) {
                        return data.videos[a].tsUnslotted - data.videos[b].tsUnslotted;
                    });
                if (keys.length > 0) {
                    var min = data.videos[keys[0]].tsUnslotted;
                    keys = keys.filter(function (fid) {
                        return data.videos[fid].tsUnslotted === min;
                    });
                }
                if (keys.length > 0) {
                    newfid = keys[Math.floor(Math.random() * keys.length)];
                }
            }
            self.logLayout('getLayoutPageRandomUnslot() => ' + newfid);
            return newfid;
        }

        // called when videos are changed - enabled/disabled - and why?
        function onLayoutPageVideoChanges(changes, reason) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;

            var enabling = changes
                .filter(function (item) {
                    return item.value;
                })
                .map(function (item) {
                    return item.fid;
                });
            var disabling = changes
                .filter(function (item) {
                    return !item.value;
                })
                .map(function (item) {
                    return item.fid;
                });
            self.logLayout(
                'onLayoutPageVideoChanges() changes=' +
                    changes.length +
                    ' enabling=' +
                    (enabling.length > 0 ? enabling.join(',') : 'none') +
                    ' disabling=' +
                    (disabling.length > 0 ? disabling.join(',') : 'none')
            );

            disabling.forEach(function (fid) {
                var item = data.videos[fid];
                if (!item.self && !item.content) {
                    self.setVideoStatsAddRemove(fid, item.div, false);
                }
            });
            enabling.forEach(function (fid) {
                var item = data.videos[fid];
                if (!item.self && !item.content) {
                    self.setVideoStatsAddRemove(fid, item.div, true);
                }
            });

            var data1 = self.layoutPageReuse;
            var max = Math.max(data.cutoff, data.pageSize);
            if (!self.hasTestLayout && data1.enabled && data1.enableWrapper) {
                // switch publisher on existing.
                self.onLayoutPageSubscriberChange(enabling, disabling, reason);
                return;
            }

            changes.forEach(function (item) {
                var div = data.videos[item.fid].div;
                if (div) {
                    // video was enabled
                    if (item.value) {
                        if (self.hasTestLayout) {
                            // simulate a delay in re-start
                            $timeout(function () {
                                var item1 = data.videos[div.getAttribute('user')];
                                if (item1 && item1.visible) {
                                    div.removeAttribute('visible');
                                }
                            }, Math.random() * 1000 + 1000);
                        } else {
                            // TODO: make it visible after video resumes.
                            div.removeAttribute('visible');
                        }

                        if (div.remoteFeed) {
                            delete div.remoteFeed.layoutHidden;
                            self.pauseVideoPlay(div.remoteFeed, false);
                        }
                    } else {
                        // video was disabled
                        $timeout(function () {
                            var item1 = data.videos[div.getAttribute('user')];
                            if (item1 && !item1.visible) {
                                div.setAttribute('visible', 'false');
                            }

                            if (div.remoteFeed) {
                                // TODO: should wait for connection to complete.
                                div.remoteFeed.layoutHidden = true;
                                self.pauseVideoPlay(div.remoteFeed, true);
                            }
                        }, 500);
                    }
                }
            });
        }

        // move the src video to dest in slots.
        function onLayoutPageVideoMove(src, dest) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            var fid0 = src.getAttribute('user'),
                fid1 = dest.getAttribute('user');

            var i = data.slots.indexOf(fid0),
                j = data.slots.indexOf(fid1);
            if (i >= 0 && j >= 0) {
                if (i < data.pinnedCount && j < data.pinnedCount) {
                    logService.log('videoroomCtrl cannot move pinned items as that must be sorted.');
                } else if (i < data.pinnedCount && j >= data.pinnedCount) {
                    logService.log('videoroomCtrl moving pinned ' + fid0 + ' to unpinned');
                    if (data.videos[fid0].pinned) {
                        self.onToggleLayoutPin(fid0, false);
                    }
                } else if (i >= data.pinnedCount && j < data.pinnedCount) {
                    logService.log('videoroomCtrl moving unpinned ' + fid0 + ' to pinned');
                    if (!data.videos[fid0].pinned) {
                        self.onToggleLayoutPin(fid0, true);
                    }
                } else {
                    // both unpinned
                    logService.log(
                        'videoroomCtrl moving video box from slots index ' +
                            i +
                            ' to ' +
                            j +
                            ' for fid=' +
                            fid0 +
                            ' to ' +
                            fid1
                    );
                    data.slots.splice(i, 1);
                    data.slots.splice(j, 0, fid0);
                }
            } else {
                logService.log(
                    'videoroomCtrl cannot move as not found fid=' + fid0 + ',' + fid1 + ' index=' + i + ',' + j
                );
            }
        }

        // update slots if there is change in cutoff due to change in layout value and lessInGrid or lessInSpotlight attribute.
        function onLayoutPageUpdateLessCutoff(oldValue, value) {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;

            var oldCutoff = data.cutoff;
            var sizeCutoff = data.sizeCutoff[data.videoSize];
            var newCutoff =
                (data.lessInGrid && value != 'allhands') || (data.lessInSpotlight && value == 'spotlight')
                    ? sizeCutoff[2]
                    : sizeCutoff[0];
            if (oldCutoff == newCutoff) {
                return;
            }

            data.cutoff = newCutoff;
            self.onLayoutReuseUpdateCutoff();
            self.onLayoutPageUpdateCutoff(oldCutoff, newCutoff);
        }

        function onLayoutPageUpdateCutoff(oldCutoff, newCutoff) {
            if (!self.layoutPage) {
                return;
            }
            var data = self.layoutPageData;

            if (oldCutoff > data.cutoff) {
                // reduce
                if (data.slots.length > data.cutoff) {
                    // TODO: use pinned, talker history too, similar to getLayoutPageRandomSlot().
                    var removed = [];
                    for (
                        var j = data.slots.length - 1;
                        j >= 0 && removed.length < data.slots.length - data.cutoff;
                        --j
                    ) {
                        // reverse order is important.
                        var item = data.videos[data.slots[j]];
                        if (item && !item.content && !item.self && (!item.div || item.div != self.maxvideo)) {
                            removed.push({ index: j, fid: data.slots[j] });
                        }
                    }
                    removed.forEach(function (item) {
                        // reverse order causes index in slots to be valid after remove.
                        data.slots.splice(item.index, 1);
                    });
                    self.logLayout(
                        'cutoff changed ' +
                            oldCutoff +
                            '=>' +
                            data.cutoff +
                            ', removing ' +
                            removed.length +
                            ' videos from slots: ' +
                            removed
                                .map(function (item) {
                                    return item.fid;
                                })
                                .join(',')
                    );
                    removed.forEach(function (item) {
                        self.setLayoutPageVideoSlotted(item.fid, false);
                    });
                } // else no change
            } else if (oldCutoff < data.cutoff) {
                // expand
                if (data.slots.length < data.cutoff && data.slots.length < data.videoCount) {
                    // TODO: optimize to move all to slots if data.cutoff is more than data.videoCount.
                    var diff = Math.min(data.cutoff - data.slots.length, data.videoCount - data.slots.length);
                    var added = [];
                    for (var i = 0; i < diff; ++i) {
                        // TODO: should also prefer pinned.
                        var newfid = self.getLayoutPageRandomUnslot();
                        if (newfid !== null && newfid !== undefined) {
                            added.push(newfid);
                            data.slots.push(newfid);
                            self.setLayoutPageVideoSlotted(newfid, true);
                        }
                    }
                    if (self.layoutOrder && self.layoutOrder != 'id') {
                        self.onLayoutPageOrderedSlots();
                    }
                    self.logLayout(
                        'cutoff changed ' +
                            oldCutoff +
                            '=>' +
                            data.cutoff +
                            ', added ' +
                            added.length +
                            ' vidoes to slots: ' +
                            added.join(',')
                    );
                } // else no change
            } // else no change
            // if (oldCutoff != data.cutoff) {
            //     data.pageSize = data.cutoff; // TODO; update realSize, rows, columns too.
            // }
        }

        // for jumping workaround with delayupdate config, ANYAM-80541.
        // return true if update videos layout is delayed or ignored for this iteration.
        function onLayoutPageBeforeUpdate() {
            var data = self.layoutPageData;
            if (self.layoutPage && data.jumpingWorkaround == 'delayupdate') {
                if (data.layout == 'allhands') {
                    if (self.layoutPageLastUpdateTimeout) {
                        data.pendingUpdate++;
                        return true;
                    } else {
                        self.layoutPageLastUpdateTimeout = $timeout(function () {
                            self.layoutPageLastUpdateTimeout = null;
                            if (data.pendingUpdate > 0) {
                                data.pendingUpdate = 0;
                                self.updateVideosLayout();
                            }
                        }, data.minUpdateDuration);
                    }
                } else {
                    data.pendingUpdate = 0; // reset.
                    if (self.layoutPageLastUpdateTimeout) {
                        $timeout.cancel(self.layoutPageLastUpdateTimeout);
                        self.layoutPageLastUpdateTimeout = null;
                    }
                }
            }
            return false;
        }

        // reset the delayupdate timer if any.
        function onLayoutPageResetAll() {
            if (self.layoutPage) {
                var data = self.layoutPageData;

                if (data.jumpingWorkaround == 'delayupdate') {
                    data.pendingUpdate = 0; // reset.
                    if (self.layoutPageLastUpdateTimeout) {
                        $timeout.cancel(self.layoutPageLastUpdateTimeout);
                        self.layoutPageLastUpdateTimeout = null;
                    }
                }
                if (data.jumpingWorkaround == 'delayattendee') {
                    for (var id in self.layoutPageMissingFeed) {
                        delete self.layoutPageMissingFeed[id];
                    }
                }
            }
        }

        // rate control to mitigate too many start play during reconnect or when postponed.
        // logic is similar to onLayoutPageBeforeUpdate().
        function onLayoutPageDelayAttendeeListSync() {
            var data = self.layoutPageData;
            if (self.layoutPage && data.jumpingWorkaround == 'delayattendee') {
                var now = Date.now();

                if (self.layoutPageLastSyncTimeout) {
                    if (now >= data.lastSyncTime + data.minSyncDuration - 500) {
                        $timeout.cancel(self.layoutPageLastSyncTimeout);
                        self.layoutPageLastSyncTimeout = null;
                        data.pendingSync = 0;
                        // fallback to continue with sync.
                    } else {
                        data.pendingSync++;
                        return true; // delay sync
                    }
                } else {
                    self.layoutPageLastSyncTimeout = $timeout(function () {
                        self.layoutPageLastSyncTimeout = null;
                        if (data.pendingSync > 0) {
                            data.pendingSync = 0;
                            self.syncAttendeeListVideoMuteStates();
                        }
                    }, data.minSyncDuration + 1000);
                    // fallback to continue with sync.
                }

                data.lastSyncTime = now;
            }

            return false;
        }

        // remove from list [{id: ...}] if id is recently missing feed, not screen share.
        function onLayoutPageDelayMissingFeed(list) {
            var data = self.layoutPageData;
            if (self.layoutPage && data.jumpingWorkaround == 'delayattendee') {
                var now = Date.now();
                var removed = [];
                list = list.filter(function (value) {
                    var item = self.layoutPageMissingFeed[value.id];
                    var result = value.screen || !item || now >= item + data.missingRetryAfter;
                    if (!result) {
                        removed.push(value.id);
                    }
                    return result;
                });
                if (removed.length > 0) {
                    logService.log('videoroomCtrl delaying play start of recently missing feeds, ' + removed.length);
                    if (self.layoutPageLastSyncTimeout) {
                        data.pendingSync++;
                    } else {
                        self.layoutPageLastSyncTimeout = $timeout(function () {
                            self.layoutPageLastSyncTimeout = null;
                            if (data.pendingSync > 0) {
                                data.pendingSync = 0;
                                self.syncAttendeeListVideoMuteStates();
                            }
                        }, data.minSyncDuration + 1000);
                    }
                }
            }
            return list;
        }

        // for jumping workaround with delayattendee config, ANYAM-80541.
        // if an attendee video div is removed, and re-added, then delay re-add by 3s.
        // during this time if more remove/add were done for that attendee, then further delay re-add
        // to 3s after the last add stabilizes. And if last was remove, then do not add.
        // this is called from start/stopVideoPlay.
        function onLayoutPageJumpingWorkaround(isStop, fid, args) {
            var data = self.layoutPageData;

            if (data.jumpingWorkaround == 'delayattendee') {
                // timer to call startVideoPlay if needed. also cleans up the state.
                var createTimer = function (attendeeData) {
                    if (attendeeData.timeout) {
                        $timeout.cancel(attendeeData.timeout);
                        delete attendeeData.timeout;
                    }
                    attendeeData.timeout = $timeout(function () {
                        var attendeeData = self.layoutPageAttendeeData[fid];
                        if (attendeeData) {
                            delete self.layoutPageAttendeeData[fid]; // delete info about previous remove.
                            if (attendeeData.args) {
                                logService.log(
                                    'videoroomCtrl - jumpingWorkaround - delayed start-video-play for fid=' + fid
                                );
                                self.msgflowEvent('play-start:jumping:' + fid, {
                                    reason: 'delayed start on jumping',
                                    id: fid
                                });
                                self.startVideoPlay.apply(self, attendeeData.args);
                            }
                        }
                    }, data.minRestartDuration);
                };

                var attendeeData = self.layoutPageAttendeeData[fid];
                if (isStop) {
                    if (!attendeeData) {
                        // no previous info.
                        attendeeData = self.layoutPageAttendeeData[fid] = {};
                    }
                    attendeeData.stopCount = (attendeeData.stopCount || 0) + 1;
                    createTimer(attendeeData); // so that cleanup can happen too.

                    if (attendeeData.args) {
                        // start was postponed, so postpone stop too.
                        delete attendeeData.args; // causes no action on timeout
                        return true; // do not continue with stop
                    } // else continue with stop.
                } else {
                    if (attendeeData && attendeeData.stopCount > 1) {
                        // first stop/start is not worked around.
                        attendeeData.args = args;
                        createTimer(attendeeData);
                        return true; // do not continue with start.
                    } // else continue with start.
                }
            }

            return false;
        }

        // dispatch videoroom-layout-controls event to enable/disable controls.
        // this applies to both with and without layoutPage, with optional extra event for layoutPage.
        function onLayoutVideoCountChange() {
            var previous = self.layoutVideoCount;
            var value = $window.$('#videoroom-videos > div[user]:not(.video-avatar-container):not(.audioonly)').length;
            self.layoutVideoCount = value;
            var hasSelf = $window.$('#videoroom-videos div.local[enable="true"]:not(.audioonly)').length > 0; // local preview

            var enable = (value >= 2 && !hasSelf) || value >= 3; // enable spotlight/gallery control.
            var changed = false;
            if (enable != self.layoutControls.enable) {
                self.logLayout(`layout controls enable ${self.layoutControls.enable} => ${enable}`);
                self.layoutControls.enable = enable;
                changed = true;
            }

            if (self.layoutPage && value >= 3) {
                // this part deals with allhands control
                var data = self.layoutPageData;
                var allhands = self.layoutControls.allhands;
                if (value > previous && value >= data.cutoff + 1) {
                    allhands = true;
                } else if (value < previous && value < Math.round(data.cutoff * 0.85)) {
                    allhands = false;
                }
                self.logLayout(
                    `layout controls allhands ${self.layoutControls.allhands} => ${allhands}, value=${value}, previous=${previous}, cutoff=${data.cutoff},${self.layoutPageData.cutoff}`
                );
                if (allhands != self.layoutControls.allhands) {
                    self.layoutControls.allhands = allhands;
                    changed = true;
                    if (allhands && data.layout != 'allhands') {
                        $rootScope.$broadcast('lgv-available');
                        analyticsWrapperService.eventTrack('Meeting - Large Gallery View Layout Enabled By Feed Count');
                    } else if (!allhands && data.layout == 'allhands') {
                        $rootScope.$broadcast('change-videoroom-layout', {
                            newLayout: videoroomService.getPreviousLayout()
                        });

                        analyticsWrapperService.eventTrack(
                            'Meeting - Large Gallery View Layout Disabled By Feed Count'
                        );
                    }
                }
            }
            if (changed) {
                $rootScope.$broadcast('videoroom-layout-controls', self.layoutControls);
                digest();
            }
        }

        // similar to onLayoutVideoCountChange, for updating allhands
        function onLayoutPageUpdateControls() {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            var count = $window.$('#videoroom-videos > div[user]:not(.video-avatar-container):not(.audioonly)').length;

            if (count > 3) {
                var allhands = count >= data.cutoff + 1;
                if (allhands != self.layoutControls.allhands) {
                    self.layoutControls.allhands = allhands;
                    if (allhands && data.layout != 'allhands') {
                        $rootScope.$broadcast('lgv-available');
                        analyticsWrapperService.eventTrack(
                            'Meeting - Large Gallery View Layout Enabled By Size Change'
                        );
                    } else if (!allhands && data.layout == 'allhands') {
                        $rootScope.$broadcast('change-videoroom-layout', {
                            newLayout: videoroomService.getPreviousLayout()
                        });

                        analyticsWrapperService.eventTrack(
                            'Meeting - Large Gallery View Layout Disabled By Size Change'
                        );
                    }

                    $rootScope.$broadcast('videoroom-layout-controls', self.layoutControls);
                    digest();
                }
            }
        }

        function onLayoutPageLowWebcamLimit(low) {
            if (!self.layoutPage) {
                return;
            }

            var data = self.layoutPageData;
            if (low) {
                //since 'xlarge' is the largest size, we do not want to move down a size in LPM...
                //TODO: remove the hardcoded check and instead compare existing videoSize with target lowWebcamLimit size
                if (data.videoSize === 'xlarge') {
                    logService.log(
                        'videoroomCtrl - current videoSize is larger than lowWebcamLimit... will not apply LPM webcam limit'
                    );
                    return;
                }

                logService.log('videoroomCtrl - applying LPM webcam limit');
                data.previousVideoSize = data.videoSize;
                self.onLayoutPageSet(data.lowWebcamLimit);
            } else {
                logService.log('videoroomCtrl - removing LPM webcam limit');
                self.onLayoutPageSet(data.previousVideoSize || data.videoSize);
            }
        }

        function layoutPageDisableAnimation() {
            var result = {};
            self.layoutPageAnimationAttrs.forEach(function (attr) {
                result[attr] = self.layoutPageData[attr];
                self.layoutPageData[attr] = false;
            });
            return result;
        }

        function layoutPageUpdateAnimation(data) {
            self.layoutPageAnimationAttrs.forEach(function (attr) {
                self.layoutPageData[attr] = data[attr] || false;
            });
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
